import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Modal from '../../../../components/Modal';
import Row from '../../../../components/Row';
import leftArrow from '../../../../assets/arrow-left-circle-line.svg';
import rightArrow from '../../../../assets/arrow-right-circle-line.svg';
import ImageSkeleton from '../../../../components/Skeletons/ImageSkeleton';

const ImageModal = (props) => {
  const {
    isModalOpen,
    onClose,
    image,
    onNextImageClick,
    onPreviousImageClick,
  } = props;
  if (!isModalOpen) return null;

  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const imageClassName = cn('image -with-border', {
    '-hidden': !isImageLoaded,
  });
  const scrollContainerClassName = cn(
    { 'skeleton-container': !isImageLoaded },
    { 'scroll-container': isImageLoaded }
  );

  const handleImageLoaded = () => {
    setIsImageLoaded(true);
  };

  return (
    <Modal
      title="Receipt/Screenshot"
      isModalOpen={isModalOpen}
      onClose={onClose}
    >
      <Row className="-centred-content">
        <button className="action-button" onClick={onPreviousImageClick}>
          <img
            className="left-arrow-icon"
            alt="left-arrow-button"
            src={leftArrow}
          />
        </button>
        <div className={scrollContainerClassName}>
          {!isImageLoaded && <ImageSkeleton />}
          <img
            src={image.url}
            className={imageClassName}
            onLoad={handleImageLoaded}
          />
        </div>
        <button className="action-button" onClick={onNextImageClick}>
          <img
            className="right-arrow-icon"
            alt="right-arrow-button"
            src={rightArrow}
          />
        </button>
      </Row>
      <div className="modal-actions">
        <button className="button -in-group" onClick={onClose}>
          Close
        </button>
      </div>
    </Modal>
  );
};

ImageModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  image: PropTypes.PropTypes.shape().isRequired,
  onNextImageClick: PropTypes.func.isRequired,
  onPreviousImageClick: PropTypes.func.isRequired,
};

export default ImageModal;
